// extracted by mini-css-extract-plugin
module.exports = {"projectName":"Project_projectName__r7oSD","block":"Project_block__2escA","img":"Project_img__3ss68","title":"Project_title__20Qa6","location":"Project_location__1Asr6"};